export enum NavigationTabs {
  ProductTaxonomy = "ProductTaxonomy",
  AdditionalProductInfo = "AdditionalProductInfo"
}